import React from "react";
import {AppBar, MenuItemLink, UserMenu} from "react-admin";
import Typography from "@mui/material/Typography";
import SettingsIcon from "@mui/icons-material/Settings";
import {makeStyles} from "@mui/styles";

const useStyles = makeStyles({
    title: {
        flex: 1,
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden",
    },
    spacer: {
        flex: 1,
    },
    appBar: {
        backgroundColor: '#a60012',
    },
});

const CustomUserMenu = (props) => (
    <UserMenu {...props}>
        <MenuItemLink
            // ref={ref}
            to="/configuration"
            primaryText={"Configuration"}
            onClick={props.onClick}
            leftIcon={<SettingsIcon/>}
        />
    </UserMenu>
);

const CustomAppBar = (props) => {
    const classes = useStyles();
    return (
        <AppBar
            {...props}
            elevation={1}
            className={classes.appBar}
            // userMenu={<CustomUserMenu/>}
        >
            <Typography variant="h6" color="inherit" className={classes.title} id="react-admin-title"/>
            {/* <Logo /> */}
            <span className={classes.spacer}/>
        </AppBar>
    );
};

export default CustomAppBar;
